import React, { useState, useEffect, Fragment, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import i18n from '../i18n';
import Navbar from "../Navbar";
import Footer from "../Footer";
import AOS from 'aos';
import 'aos/dist/aos.css';
import $ from 'jquery';
const { config } = require('../api/api');

function DhofarMotorinsuranceoffers() {

    const { t } = useTranslation();
    const base_url = config.baseURL;
    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
    const [loading, setLoading] = useState(false);
    const reg_type = ["Oman Plate", "GCC Plate", "Import", "Export"];
    const reg_mark = [
      "10", "11", "12", "14", "15", "16", 
      "A A", "B K", "D D", "H W", "A D", "M", "A R", "H H", 
      "L K", "H A", "B M", "BANK", "C D", "D A", "Inspection", 
      "M B", "M S", "MUSCAT", "R A", "R H", "T", "T B", "W A", 
      "1", "2", "3", "4", "5", "6", "7", "8", "9", "L D", "M L", 
      "M Y", "Y M", "Y R", "M W", "R R", "T A", "T B A", "Y", 
      "A W", "K B", "L A", "K H", "M D", "M K", "R W", "Y W", 
      "A Y", "B B", "B H", "D H", "D Y", "H", "I N T L", "K", 
      "D R", "D S", "H Y", "IMPORT", "J", "K A", "B R", "B S", 
      "D", "D W", "H K", "H M", "H R", "R", "T T", "Y A", "Y B", 
      "R K", "R S", "W", "Y D", "Y Y", "K K", "S S", "Y S", "A", 
      "B", "B D", "A B", "A K", "A S", "B W", "B Y", "D K", 
      "H D", "H S", "M A", "A M", "M M", "M R", "R M", "S", 
      "S H", "W B", "W K", "T H", "T D", "R Y", "W W", "L B", 
      "L A", "L H", "B A", "M H", "17", "18", "19", "20", "21", 
      "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", 
      "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", 
      "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", 
      "52", "53", "54", "55", "56", "57", "58", "59", "60", "61", 
      "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", 
      "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", 
      "82", "83", "84", "85", "86", "87", "88", "89", "90", "91", 
      "92", "999", "UAE", "Dubai", "Abu Dhabi", "Fujairah", "Sharjah", 
      "Qatar", "Kuwait", "KSA", "Ras Al - Khaimah", "Umm Al - Quwain", 
      "Ajman", "Bahrain"
    ];
    const selectOpt1=useRef(null);
    const [vendorKey, setVendorkey] = useState('');

      useEffect(() => {
    
        const postvData = { organization_name: "Superjet" };
        debugger
    
        if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
    
          debugger
          fetch(base_url + '/create_organization', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(postvData),
          })
            .then(response => response.json())
            .then(data => {
              setVendorkey(data.result[0].vendor_key);
            })
            .catch(error => {
              console.error('Error posting data:', error);
            });
    
    
        }
      }, [vendorKey]);
  const changeLanguage = (lng) => {

    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (1 * 60 * 60 * 1000));

    Cookies.set('langData', lng, { expires: expiryDate });

    i18n.changeLanguage(lng);
  };

    
    const [insData, setData] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isHovered1, setIsHovered1] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);

    const [formData,setFormData]=useState({
      plate_number:"",
      plate_code:"",
      chasis_no:"",
      vehicle_value:"",
      civil_id:"",
      plate_reg_type:"",
      registration_mark:""
    });
    
    useEffect(() => {
        // debugger
      const storeddata = sessionStorage.getItem('motorinsurancePlan');
        if (storeddata!==undefined && storeddata!==null) {
          const storeddt = JSON.parse(storeddata);
          setData(storeddt);
        }
        else
        {
            window.location.href = '/motor-insurance';
        }
    }, []);

    useEffect(() => {
      $(selectOpt1.current).select2({width:"100%"});
      $(selectOpt1.current).on('select2:select', (e) => {
        debugger
        const selectedValue = e.params.data.text;
        const selected_id = e.params.data.id;
  
        setFormData((data)=>({...data,["registration_mark"]:selected_id}));
        
      });
  
      // Clean up Select2 instance on unmount
      return () => {
        $(selectOpt1.current).select2('destroy');
      };
    }, [vendorKey]);
  
  // Function to update HTML dir attribute based on language
  const updateHtmlDirAttribute = () => {
    document.documentElement.dir = i18n.dir(); // Set document direction
  };

  // Update HTML dir attribute when component mounts and language changes
  useEffect(() => {
    updateHtmlDirAttribute();
  }, [i18n.language]);

  useEffect(()=>{
    AOS.init({duration:600});
  },[]);

  const handleBack= async (event) => {
    event.preventDefault();

    window.location.href = "/dhofar-motorinsurance"

  };
  useEffect(()=>{
   const form_info= sessionStorage.getItem("Motor_Form_Details");
   if(form_info){
    const parse_form_data= JSON.parse(form_info);
    setFormData(parse_form_data);
   }
  },[])


  const handlethird = async (event) => {
debugger
    event.preventDefault();
    setLoading(true);
    var valid = true ;
    const {chasis_no,...form}=formData;
    const formKeys=Object.keys(form);
    for(let i=0;i<formKeys.length;i++){
      const key =formKeys[i];
      if(formData[key]===undefined || formData[key]===null|| formData[key]===""){
       valid =false ;
       setLoading(false);
       return;
      }
    }
    if(valid){
    sessionStorage.setItem("Motor_Form_Details",JSON.stringify(formData))

    window.location.href = "/dhofar-motor-thirdparty"
    }

  };


  const handlecomprehensive = async (event) => {
    event.preventDefault();
    debugger
    setLoading(true);
    var valid = true ;
    const {chasis_no,...form}=formData;
    const formKeys=Object.keys(form);
    for(let i=0;i<formKeys.length;i++){
      const key =formKeys[i];
      if(formData[key]===undefined || formData[key]===null|| formData[key]===""){
       valid =false ;
       setLoading(false);
       return;
      }
    }
    if(valid){
    sessionStorage.setItem("Motor_Form_Details",JSON.stringify(formData))
    window.location.href = '/dhofar-motor-comperhensive'
    }
  }

  const handleChange=(e)=>{
   const name=e.target.name;
   const value= e.target.value;
   setFormData((data)=>({...data,[name]:value}));
  }

  return (
    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-3">{(lnstr === 'en') ? 'Details Page': 'تحميل السياسة\n'}</h3>
          </div>
        </div>


      </div>


      <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={1}></Col>

            <Col md={10} className="myforms my-5">
            <div class="card" data-aos='fade-up'>
  <div class="card-body">
    <h4><strong>Vehicle Details</strong></h4>
    {/* <div class="d-flex justify-content-between"> */}
      <div className="row">
      <div className="col-lg-3 col-md-6 col-sm-12 col-12">
        <span>Plate Number<span style={{ color: 'red' }}>&nbsp;*</span></span>
        <div><input type="text" name="plate_number" className="form-control" value={formData?.plate_number}  onChange={handleChange}/></div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-12 col-12">
        <span>Plate Code<span style={{ color: 'red' }}>&nbsp;*</span></span>
        <div><input type="text" name="plate_code" className="form-control" value={formData?.plate_code}  onChange={handleChange} /></div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-12 col-12">
        <span>Plate Registration Type<span style={{ color: 'red' }}>&nbsp;*</span></span>
        <div><select name="plate_reg_type" style={{fontSize:"13px"}} className="form-control fs-3" value={formData?.plate_reg_type} onChange={handleChange}>
        <option  style={{fontSize:"14px"}} value={""}>--select--</option>
        {reg_type.map((option, index) => (
          <option  style={{fontSize:"14px"}} key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
</div>
      </div>
 
      <div className="col-lg-3 col-md-6 col-sm-12 col-12">
        <span>Chasis No<span style={{ color: 'red' }}>&nbsp;*</span></span>
        <div><input type="text" name="chasis_no" className="form-control" value={formData?.chasis_no}  onChange={handleChange} /></div>
      </div>
      <div className="col-lg-3 mt-md-2 col-md-6 col-sm-12 col-12">
        <span>Registration Mark<span style={{ color: 'red' }}>&nbsp;*</span></span>
        <div><select ref={selectOpt1}  name="registration_mark" className="form-control" value={formData?.registration_mark}  onChange={handleChange} >
        <option value={null}>--select--</option>
        {reg_mark.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
        </select></div>
      </div>
      <div className="col-lg-3 mt-md-2 col-md-6 col-sm-12 col-12">
        <span>Vehicle Value<span style={{ color: 'red' }}>&nbsp;*</span></span>
        <div><input type="text" name="vehicle_value" className="form-control" value={formData?.vehicle_value}  onChange={handleChange} /></div>
      </div>
    </div>
    {/* </div> */}
    <hr/>
    <h4><strong>Personal Details</strong></h4>
    {/* <div class="d-flex justify-content-between"> */}
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        <span>Civil Id<span style={{ color: 'red' }}>&nbsp;*</span></span>
        <div><input type ="text" name="civil_id" className="form-control" value={formData?.civil_id}  onChange={handleChange} /></div>
      </div>
      {/* <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        <span>Last Name</span>
        <div><input type ="text" name="last_name" className="form-control" value={formData?.last_name}  onChange={handleChange} /></div>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        <span>Mobile Number</span>
        <div><input type="text" name="personal_mobile_number" className="form-control" value={formData?.personal_mobile_number}  onChange={handleChange} /></div>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        <span>Expiry Date</span>
        <div><input type="Date" name="license_expiry_date" className="form-control" value={formData?.license_expiry_date}  onChange={handleChange} /></div>
      </div> */}
    {/* </div> */}
  </div>
</div>
</div>

<div className="p-3" data-aos='fade-up'>
  <div className="row" style={{ display: 'flex', justifyContent: 'space-between' }}>

<div className="col-lg-7 col-md-5 col-sm-6 col-6">
  <button type ='submit' className=" rounded-pill text-white my-1 py-1 px-4 " onClick={handleBack} style={{
            backgroundColor: isHovered2 ? '#0b8ba8' : '#33d0f2',
            transition: 'background-color 0.3s ease',
          }}  onMouseEnter={() => setIsHovered2(true)} onMouseLeave={() => setIsHovered2(false)}>Back</button>
          </div>

          <div className="col-lg-5 col-md-7 col-sm-6 col-6 d-flex flex-column flex-md-row justify-content-end " style={{gap:"15px"}}>
    <button type ='submit' className=" rounded-pill text-white my-1 py-1 px-2" onClick={handlethird} style={{
            backgroundColor: isHovered ? '#0b8ba8' : '#33d0f2',
            transition: 'background-color 0.3s ease',
          }}  onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>Third Party</button>

    <button type ='submit' className="rounded-pill text-white my-1 py-1 px-2 ml-0" onClick={handlecomprehensive}style={{
            backgroundColor: isHovered1 ? '#0b8ba8' : '#33d0f2',
            transition: 'background-color 0.3s ease',
            marginLeft:'6px' , textAlign:'center'
          }}  onMouseEnter={() => setIsHovered1(true)} onMouseLeave={() => setIsHovered1(false)}>Comprehensive</button>
</div>


</div>
</div>
<div>

</div>



          
        </Col>

            <Col md={1 }></Col>

          </div>


        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>
  );
}

export default DhofarMotorinsuranceoffers;